package com.tixforgigs.common.ui.components.forms

import io.kvision.core.Container
import io.kvision.material.ExperimentalMaterialApi
import io.kvision.panel.SimplePanel
import io.kvision.panel.simplePanel

@OptIn(ExperimentalMaterialApi::class)
fun Container.fieldsPanel(
  init: (SimplePanel.() -> Unit)? = null
): SimplePanel = simplePanel(
  className = "xm-fields xm-col xm-gap",
  init = init
)

fun Container.fieldsGapPanel(
  init: (SimplePanel.() -> Unit)? = null
): SimplePanel = simplePanel(
  className = "xm-fields xm-col xm-gap xm-gap-medium",
  init = init
)

fun Container.fieldFullPanel(
  init: (SimplePanel.() -> Unit)? = null
): SimplePanel = simplePanel(
  className = "xm-field xm-full",
  init = init
)

fun Container.fieldCenterPanel(
  init: (SimplePanel.() -> Unit)? = null
): SimplePanel = simplePanel(
  className = "xm-field xm-center",
  init = init
)

fun Container.fieldPanel(
  init: (SimplePanel.() -> Unit)? = null
): SimplePanel = simplePanel(
  className = "xm-field",
  init = init
)

fun Container.fieldSmallPanel(
  init: (SimplePanel.() -> Unit)? = null
): SimplePanel = simplePanel(
  className = "xm-field xm-third",
  init = init
)



fun Container.chipsPanel(
  init: (SimplePanel.() -> Unit)? = null
): SimplePanel = simplePanel(
  className = "xm-shipping-methods",
  init = init
)
